import { v4 as uuidv4 } from "uuid";

import { ActionTree, Module, MutationTree } from "vuex";
import { RootState } from "../../store.interface";
import { DialogStore } from "@/shared/interfaces/DialogStore.interface";
import { DialogItem, DialogOption } from "@/shared/interfaces/Dialog.interfaces";
import { i18n } from "@/shared/scripts/helpers/translation/i18n";

const state = {
    items: [] as DialogItem[],
};

const mutations: MutationTree<DialogStore> = {
    items: function(state: DialogStore, items: DialogItem[]): void{
        state.items = items;
    },

    add: function(state: DialogStore, item: DialogItem): void{
        state.items.push(item);
    },

    remove: function(state: DialogStore, item: DialogItem): void{
        const index = state.items.indexOf(item);
        state.items.splice(index, 1);
    },
};

const actions: ActionTree<DialogStore, RootState> = {

    add: function({ commit }, payload) {
        return new Promise(resolve => {
            commit("add", {
                key: uuidv4(),
                ...payload,
                resolve: resolve,
            });
        });
    },

    remove: ({ commit }, item: DialogItem) => commit("remove", item),

    alert: function({ dispatch }, payload: DialogOption = {}) {
        return dispatch("add", {
            ...{ okLabel: "OK" },
            ...payload,
        });
    },

    confirm: function({ dispatch }, payload: DialogOption = {}) {
        return dispatch("add", {
            ...{ cancelLabel: i18n.t("cancel"), okLabel: "OK" },
            ...payload,
        });
    },
};

const dialog: Module<DialogStore, RootState> = {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
};

export default dialog;
